import { cva } from "class-variance-authority";
import { cn } from "../../utils/cn";

const toggleGroupRootVariants = cva("group/toggle-group inline-flex items-center text-font-tertiary", {
  variants: {
    variant: {
      default: "rounded bg-neutral-200 p-1",
      compact: "rounded-md border border-neutral-200 bg-neutral-100 p-0.5",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const toggleGroupItemClasses = cn(
  "inline-flex items-center justify-center whitespace-nowrap text-font-tertiary transition-all",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2",
  "disabled:pointer-events-none disabled:opacity-50",
  // default variant — inherited from root via data-variant
  "group-data-[variant=default]/toggle-group:typo-body-base-regular group-data-[variant=default]/toggle-group:rounded-sm group-data-[variant=default]/toggle-group:px-3 group-data-[variant=default]/toggle-group:py-1.5",
  "group-data-[variant=default]/toggle-group:data-[state=on]:typo-body-base-medium group-data-[variant=default]/toggle-group:data-[state=on]:bg-neutral-0 group-data-[variant=default]/toggle-group:data-[state=on]:text-font-primary group-data-[variant=default]/toggle-group:data-[state=on]:shadow-sm",
  // compact variant
  "group-data-[variant=compact]/toggle-group:typo-body-xs-regular group-data-[variant=compact]/toggle-group:rounded-sm group-data-[variant=compact]/toggle-group:px-2 group-data-[variant=compact]/toggle-group:py-1",
  "group-data-[variant=compact]/toggle-group:data-[state=on]:typo-body-xs-medium group-data-[variant=compact]/toggle-group:data-[state=on]:bg-neutral-0 group-data-[variant=compact]/toggle-group:data-[state=on]:text-font-primary group-data-[variant=compact]/toggle-group:data-[state=on]:shadow-sm",
);

export { toggleGroupItemClasses, toggleGroupRootVariants };
